import {
  InboxEntryUnread,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createInboxEntryUnreadMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (action: WebSocketAction, item: InboxEntryUnread) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(
            `[InboxEntryUnreadHandler] INSERT unread ${item.inboxEntryId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.InboxEntryUnread,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        // Backend maps unread-row MODIFY to INSERT, so this won't fire today; forward guard.
        case WebSocketAction.MODIFY:
          log.debug(
            `[InboxEntryUnreadHandler] MODIFY unread ${item.inboxEntryId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.InboxEntryUnread,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(
            `[InboxEntryUnreadHandler] REMOVE unread ${item.inboxEntryId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.InboxEntryUnread,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[InboxEntryUnreadHandler] Unknown action for InboxEntryUnread:',
            action,
          );
      }
    } catch (error) {
      log.error('[InboxEntryUnreadHandler] Handler failed:', error);
    }
  };
}
